<script>
    // Licensed under Gnu Public License version 2
    // Copyright (c) 2025 (original work) Open Assessment Technologies SA ;

    import { ProgressBarCell } from '@oat-sa-private/ui-components';
    import TextCell from '@/component/ui-elements/textCell/TextCell.svelte';

    export let data;
</script>

<style>
    span {
        display: flex;
        justify-content: left;
        color: var(--color-text-disabled);
        font-size: var(--fontsize-body-s);
        font-style: italic;
        text-align: center;
    }
</style>

{#if data?.placeholder}
    <span class="reset-placeholder">
        <TextCell class="reset-label" data={{ data: data.placeholder }} />
    </span>
{:else}
    <ProgressBarCell data={data.data} />
{/if}
